module.exports = __webpack_public_path__ + "static/media/logo.ccd3e04e.png";